import * as Yup from "yup";
import {
  validateExpressionConditions,
  validateExpressionConditionsRequired,
} from "./expressionValidators";
import { mapYupFlatErrors, runSchemaWithContext } from "./yupFormUtils";
import { nameField } from "./yupCommonFields";

function buildEmptyConditionErrors(conditions) {
  return (conditions || []).map((orCond) =>
    (orCond || []).map(() => ({ key: false, condition: false, value: false })),
  );
}

const expressionRuleFormSchema = Yup.object({
  name: nameField,
  conditions: Yup.array().test("conditions", function (conditions) {
    const requireConditions = this.options.context?.requireConditions ?? true;
    const condResult = requireConditions
      ? validateExpressionConditionsRequired(conditions)
      : validateExpressionConditions(conditions);

    this.options.context.conditionErrors = condResult.errors;
    this.options.context.conditionMessage = condResult.message;

    if (!condResult.valid) {
      return this.createError({
        message: condResult.message || "Fix match condition errors",
        path: "conditions",
      });
    }
    return true;
  }),
});

export function validateExpressionRuleForm({ name, conditions, requireConditions = true }) {
  const context = {
    requireConditions,
    conditionErrors: buildEmptyConditionErrors(conditions),
    conditionMessage: undefined,
  };

  const result = runSchemaWithContext(
    expressionRuleFormSchema,
    { name, conditions, requireConditions },
    context,
  );

  if (result.valid) {
    return {
      valid: true,
      formErrors: {},
      conditionErrors: buildEmptyConditionErrors(conditions),
      conditionMessage: undefined,
    };
  }

  return {
    valid: false,
    formErrors: mapYupFlatErrors(result.err, ["name", "conditions"]),
    conditionErrors: context.conditionErrors ?? buildEmptyConditionErrors(conditions),
    conditionMessage: context.conditionMessage,
  };
}
